import { render, staticRenderFns } from "./myWarehouse.vue?vue&type=template&id=6987983a&scoped=true&"
import script from "./myWarehouse.vue?vue&type=script&lang=js&"
export * from "./myWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./myWarehouse.vue?vue&type=style&index=0&id=6987983a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987983a",
  null
  
)

export default component.exports